export const employmentTenureQuestions: Record<string, any> = {
  EMPLOYEE_PERMANENT_no: {
    startDate: {
      labelKey: 'applicationForm.EMPLOYMENT_TENURE.EMPLOYEE_PERMANENT_no.startDate',
    },
  },
  EMPLOYEE_PERMANENT_yes: {
    startDate: {
      labelKey: 'applicationForm.EMPLOYMENT_TENURE.EMPLOYEE_PERMANENT_yes.startDate',
      explanationKey: 'applicationForm.EMPLOYMENT_TENURE.EMPLOYEE_PERMANENT_yes.explanation',
    },
  },
  EMPLOYEE_CONTRACTOR: {
    startDate: {
      labelKey: 'applicationForm.EMPLOYMENT_TENURE.EMPLOYEE_CONTRACTOR.startDate',
    },
    endDate: {
      labelKey: 'applicationForm.EMPLOYMENT_TENURE.EMPLOYEE_CONTRACTOR.endDate',
    },
    yearsRequirement: 2,
  },
  SELF_EMPLOYED_LIMITED_COMPANY_GREATER: {
    startDate: {
      labelKey: 'applicationForm.EMPLOYMENT_TENURE.SELF_EMPLOYED_LIMITED_COMPANY_GREATER.startDate',
    },
    yearsRequirement: 2,
  },
  SELF_EMPLOYED_LIMITED_COMPANY_BELOW: {
    startDate: {
      labelKey: 'applicationForm.EMPLOYMENT_TENURE.SELF_EMPLOYED_LIMITED_COMPANY_BELOW.startDate',
    },
    yearsRequirement: 2,
  },
  SELF_EMPLOYED_SOLE_TRADER: {
    startDate: {
      labelKey: 'applicationForm.EMPLOYMENT_TENURE.SELF_EMPLOYED_SOLE_TRADER.startDate',
    },
    yearsRequirement: 1,
  },
  SELF_EMPLOYED_PARTNERSHIP: {
    startDate: {
      labelKey: 'applicationForm.EMPLOYMENT_TENURE.SELF_EMPLOYED_PARTNERSHIP.startDate',
    },
    yearsRequirement: 1,
  },
};
